import script from "./StatsAvgDistanceCommuted.vue?vue&type=script&lang=js"
export * from "./StatsAvgDistanceCommuted.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__